<template>
  <div>
    <el-select
      size="mini"
      v-model="positionId"
      placeholder="Selección de Cargo"
      filterable
      ref="serviceTypeFilter"
      style="width: 100%"
      clearable
      @change="onPositionSelected"
      :disabled="selectionsDisable"
      :loading="loadingpositions"
    >
      <el-option
        v-for="(pos, index) in positionList"
        :key="index"
        :value="pos.Id"
        :label="pos.Name"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "PositionsSelector",
  data() {
    return {
      positionId: "",
      selectionsDisable: false,
      loadingpositions: false,
      positionList: []
    };
  },
  mounted() {
    this.GetPositionData();
  },
  methods: {
    async GetPositionData() {
      await this.$http.get("/api/users/GetPositions").then((resp) => {
        this.positionList = resp.data;
      });
    },
    onPositionSelected(value) {
      this.$emit("posicionChange", value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
